export class ScrapeRequest
{
  url:string;
  outputData:string; 
}